import constants from "~~/constants";

type ValidationType =
  | (typeof constants.VALIDATION_TYPES)[keyof typeof constants.VALIDATION_TYPES]
  | (typeof constants.VALIDATION_TYPES.REGEX)[keyof typeof constants.VALIDATION_TYPES.REGEX];

type ValidationParams = {
  minLength?: number;
  maxLength?: number;
  pattern?: string;
  match?: string;
  min?: number;
  max?: number;
  requiredValue?: any;
  exactSelections?: number;
  minSelections?: number;
  maxSelections?: number;
  minDate?: string;
  maxDate?: string;
  equalDate?: string;
  minTime?: string;
  maxTime?: string;
  equalTime?: string;
  points?: number;
  maxDecimalPlaces?: number;
};

/**
 * Returns localized validation message based on field name and validation type
 * @param fieldName - The name of the field being validated
 * @param validationType - The type of validation that failed
 * @param params - Explicit parameters for the validation message
 * @returns Localized validation message
 */

export default (
  fieldName: string,
  validationType: ValidationType,
  params: ValidationParams = {},
): string => {
  const { $i18n } = useNuxtApp();

  if (!validationType) {
    return $i18n.t("validations.default", {
      field: fieldName,
    });
  }

  const translationParams = {
    field: fieldName,
    ...params,
  };

  return $i18n.t(`validations.${validationType}`, translationParams);
};
